import defaultRules from './default';
import terminalRules from './terminal';

export {
	defaultRules,
	terminalRules,
}